<template>
	<div>
		<div class="clearfix mb-2" v-if="ttevent">
			<h1 class="mb-0">{{ttevent.ttsessiontype_name}} {{ttevent.ttroom_name}}</h1>
			<p class="mt-0">{{ttevent.ttsessiontype_notes}}</p>
		</div>
		<div class="row">
			<div class="col-md-8">
				<div class="list-group">
					<div
						class="list-group-item list-group-item-action"
						v-for="(student, index) in students"
						v-bind:key="index"
					>
						<div class="clearfix">
							<Avatar
								class="avatar float-left mr-4 mb-0 lg:mb-0"
								:userId="student.user_id"
							/>
							<div class="float-left mr-4 mb-0">
								<h3 class="mb-0">
									{{ student.displayname }}
								</h3>
								<p class="mb-0" v-if="student.absencetype_title">
									{{ student.absencetype_title }}
								</p>
							</div>
						</div>
					</div>

					<div class="modal-mask"  v-if="selectedAbsence">
						<div class="modal-wrapper">
							<div class="modal-dialog modal-lg">
								<div class="modal-content">
									<div class="modal-header">
										<h5 class="modal-title">{{ selectedAbsence.student_displayname }}</h5>
										<button class="btn" @click="selectedAbsence=null">
											<b-icon icon="x"></b-icon>
										</button>
									</div>
									<div class="modal-body">

										<div class="mb-4">
											<h5>{{ $t('type') }}</h5>
											<div>
												<select
													class="form-control"
													v-model="selectedAbsence.type"
												>
													<option value="">{{ $t("please-select") }}</option>
													<option
														v-for="absenceType in absenceTypes"
														:key="absenceType.id"
														:value="absenceType.id"
														>{{ absenceType.title }}</option
													>
												</select>
											</div>
										</div>

										<div class="mb-4">
											<h5>{{ $t("comments") }}</h5>
											<div>
												<textarea
													class="form-control"
													v-model="selectedAbsence.comment"
												></textarea>
											</div>
										</div>

										<div>
											<button
												class="btn btn-primary"
												@click="saveAbsence"
												data-cy="save-absence-button"
											>
												{{ $t("save") }}
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import MarkAttendance from "../components/MarkAttendance";
// import students from "src/data/students";
import Avatar from "src/components/Avatar.vue";

export default {
	components: {
		Avatar
	},
	data() {
		return {
			placmentevent: null,
			students: []
		};
	},
	mounted() {
		this.getStudents();
	},
	updated() {
		//console.log("updated", this.students, this.selectedStudent);
	},
	methods: {
		getStudents(markallattended=false) {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttevent/get/`, {
				data: {
					'ttevent_id': Number(this.$route.params["eventid"])
				},
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.ttevent = res.result;

					this.$cfetch(`${this.$settings.APIBaseURL}/timetable/register/geteventregister`, {
						data: {
							'event_id': Number(this.$route.params["eventid"]),
							'mark_all_attended': markallattended
						},
					}).then((res) => {
						if (res.status === "SUCCESS") {
							this.students = res.result.students;
						} else {
							if (res.error_message) {
								this.error = res.error_message;
							} else {
								this.error = this.$t("failed-load-timetable");
							}
						}
					});
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-load-timetable");
					}
				}
			});
		},
		somethingWentWrong(){
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("oops"),
				content: this.$t("something-went-wrong")
			});
		}

	},
	computed: {
	}
};
</script>
